var _g, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLanding03Large(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 784,
    height: 307,
    viewBox: "0 0 784 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_1644)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_1_1644)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 764,
    height: 287,
    rx: 32,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4648 53.7148V78.4336H66.4023V53.7148H69.4648ZM48.9844 71.625C55.4648 68.5488 58.4453 64.3652 58.9922 58.7461H50.2422V56.3398H62.082C62.082 63.6953 59.2246 69.9434 50.5703 74.0586L48.9844 71.625ZM79.8828 54.8086C83.082 54.7949 85.5977 56.6406 86.2129 59.3477H90.6836V53.7148H93.7188V66.9766H90.6836V61.8086H86.2402C85.6523 64.584 83.1094 66.457 79.8828 66.457C76.0957 66.457 73.3477 64.0234 73.3477 60.6055C73.3477 57.2285 76.0957 54.7949 79.8828 54.8086ZM76.2461 60.6055C76.2461 62.5879 77.75 63.9004 79.8828 63.8867C81.9609 63.9004 83.4512 62.5879 83.4648 60.6055C83.4512 58.623 81.9609 57.3379 79.8828 57.3516C77.75 57.3379 76.2461 58.623 76.2461 60.6055ZM77.4219 78.1328V68.125H80.4297V70.75H90.6836V68.125H93.7188V78.1328H77.4219ZM80.4297 75.6719H90.6836V73.1016H80.4297V75.6719ZM102.031 74.0586L99.7344 81.7148H97.1367L98.5586 74.0586H102.031ZM119.832 59.6484C119.805 64.0645 122.02 68.5215 125.848 70.3672L123.988 72.8008C121.309 71.4473 119.381 68.8359 118.328 65.6914C117.248 69.0547 115.225 71.8438 112.395 73.2656L110.535 70.832C114.514 68.9453 116.783 64.2148 116.797 59.6484V55.7109H119.832V59.6484ZM127.324 78.4336V53.7148H130.359V63.3945H134.16V65.9922H130.359V78.4336H127.324ZM157.758 67.7148V70.1758H147.914V78.4062H144.906V70.1758H135.172V67.7148H157.758ZM137.934 64.8164V54.9727H154.996V64.8164H137.934ZM140.914 62.4375H151.961V57.4062H140.914V62.4375ZM179.934 53.7148V66.3203H176.926V53.7148H179.934ZM159.371 63.9141C163.377 62.6426 165.482 59.4707 165.469 56.2305V54.3164H168.613V56.2305C168.6 59.375 170.691 62.3145 174.602 63.5039L173.125 65.8555C170.254 64.9668 168.203 63.1348 167.082 60.7832C165.961 63.3398 163.855 65.3496 160.902 66.293L159.371 63.9141ZM163.582 69.8203V67.4688H179.988V73.8945H166.617V75.8086H180.727V78.2148H163.637V71.625H176.953V69.8203H163.582ZM210.805 53.7148V78.4609H207.742V53.7148H210.805ZM191.035 64.2422C191.021 58.9102 193.742 55.5195 197.488 55.5195C201.193 55.5195 203.928 58.9102 203.941 64.2422C203.928 69.6152 201.193 72.9922 197.488 72.9922C193.742 72.9922 191.021 69.6152 191.035 64.2422ZM193.961 64.2422C193.961 68.043 195.396 70.2441 197.488 70.2578C199.566 70.2441 200.988 68.043 200.988 64.2422C200.988 60.4688 199.566 58.2539 197.488 58.2539C195.396 58.2539 193.961 60.4688 193.961 64.2422ZM223.273 59.6484C223.246 64.0645 225.461 68.5215 229.289 70.3672L227.43 72.8008C224.75 71.4473 222.822 68.8359 221.77 65.6914C220.689 69.0547 218.666 71.8438 215.836 73.2656L213.977 70.832C217.955 68.9453 220.225 64.2148 220.238 59.6484V55.7109H223.273V59.6484ZM230.766 78.4336V53.7148H233.801V63.3945H237.602V65.9922H233.801V78.4336H230.766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5234 106.887C54.5234 109.953 56.5547 113.098 59.0156 114.309L58.0781 115.539C56.1641 114.533 54.5625 112.482 53.8008 110.07C53.0195 112.639 51.3789 114.826 49.4258 115.871L48.4492 114.641C50.9883 113.391 53 110.051 53.0195 106.887V103.723H54.5234V106.887ZM62.1406 102.219V109.27H65.0508V110.598H62.1406V119.582H60.6172V102.219H62.1406ZM81.8672 112.316V113.586H74.6211V119.582H73.1172V113.586H65.9688V112.316H81.8672ZM79.7969 103.195V109.953H68.0195V103.195H79.7969ZM69.5234 104.445V108.742H78.2734V104.445H69.5234ZM97.5898 102.219V111.223H96.0859V102.219H97.5898ZM97.6094 112.102V116.262H87.8633V118.137H98.2344V119.387H86.3594V115.07H96.0859V113.332H86.3203V112.102H97.6094ZM89.4258 104.055C89.4062 106.516 91.2812 108.684 93.8594 109.523L93.0977 110.715C91.0664 110.021 89.4453 108.566 88.6641 106.691C87.8828 108.713 86.252 110.305 84.1914 111.047L83.3906 109.836C86.0078 108.918 87.8633 106.613 87.8633 104.055V102.727H89.4258V104.055ZM103.41 116.691L101.887 122.004H100.441L101.516 116.691H103.41ZM116.496 105.031C116.496 107.395 118.293 109.562 120.812 110.422L119.973 111.633C118.049 110.93 116.535 109.494 115.773 107.688C115.031 109.729 113.488 111.34 111.457 112.121L110.637 110.891C113.234 109.914 114.973 107.59 114.992 104.914V103.117H116.496V105.031ZM124.27 102.219V106.75H126.887V108.039H124.27V112.785H122.746V102.219H124.27ZM118.703 113.234C122.277 113.234 124.426 114.387 124.426 116.379C124.426 118.41 122.277 119.543 118.703 119.543C115.129 119.543 112.941 118.41 112.941 116.379C112.941 114.387 115.129 113.234 118.703 113.234ZM118.703 114.465C116.086 114.465 114.465 115.188 114.484 116.379C114.465 117.609 116.086 118.312 118.703 118.332C121.34 118.312 122.941 117.609 122.941 116.379C122.941 115.188 121.34 114.465 118.703 114.465ZM132.766 103.039C135.1 103.02 136.867 104.377 137.199 106.379H140.832V102.219H142.375V111.535H140.832V107.648H137.219C136.906 109.699 135.119 111.066 132.766 111.066C130.129 111.066 128.254 109.426 128.254 107.043C128.254 104.68 130.129 103.02 132.766 103.039ZM132.766 104.348C130.988 104.328 129.719 105.441 129.719 107.043C129.719 108.625 130.988 109.777 132.766 109.777C134.523 109.777 135.773 108.625 135.773 107.043C135.773 105.441 134.523 104.328 132.766 104.348ZM132.727 112.414V114.621H140.832V112.414H142.375V119.348H131.184V112.414H132.727ZM132.727 118.098H140.832V115.852H132.727V118.098ZM153.117 113.195C156.848 113.195 159.211 114.367 159.211 116.379C159.211 118.371 156.848 119.543 153.117 119.543C149.406 119.543 147.043 118.371 147.043 116.379C147.043 114.367 149.406 113.195 153.117 113.195ZM153.117 114.367C150.344 114.387 148.547 115.148 148.566 116.379C148.547 117.59 150.344 118.332 153.117 118.332C155.891 118.332 157.668 117.59 157.688 116.379C157.668 115.148 155.891 114.387 153.117 114.367ZM159.074 103.117V104.582C159.074 105.988 159.074 107.395 158.586 109.191L157.082 109.016C157.551 107.219 157.551 105.949 157.551 104.582V104.367H147.16V103.117H159.074ZM161.086 110.324V111.574H145.285V110.324H151.828V106.965H153.332V110.324H161.086ZM176.125 102.219V107.512H178.742V108.801H176.125V114.934H174.582V102.219H176.125ZM171.438 103.566C171.438 108.039 168.234 111.359 163.234 112.922L162.57 111.691C166.73 110.393 169.445 107.912 169.777 104.855H163.293V103.566H171.438ZM176.926 117.922V119.211H165.246V113.645H166.77V117.922H176.926Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1644",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 764,
    height: 287
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 764,
    height: 287,
    rx: 32,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273 188.24C273 182.585 277.585 178 283.24 178H388.2C393.855 178 398.44 182.585 398.44 188.24V292.56H273V188.24Z",
    fill: "#E9F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.88 84.24C376.88 78.5846 381.464 74 387.12 74H492.08C497.735 74 502.32 78.5846 502.32 84.24V218H376.88V84.24Z",
    fill: "#E9F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.76 205.201C675.76 199.546 680.344 194.961 686 194.961H790.96C796.615 194.961 801.2 199.546 801.2 205.201V292.241H675.76V205.201Z",
    fill: "#E9F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.6 138.223C599.6 136.151 600.849 134.283 602.765 133.491L660.365 109.687C661.617 109.17 663.023 109.17 664.276 109.687L721.876 133.491C723.791 134.283 725.04 136.151 725.04 138.223V292.239H599.6V138.223Z",
    fill: "#F96C44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.72 145.041C348.72 139.385 353.305 134.801 358.96 134.801H463.92C469.576 134.801 474.16 139.385 474.16 145.041V292.241H348.72V145.041Z",
    fill: "#C4D5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.16 176.399C474.16 173.572 476.452 171.279 479.28 171.279H594.48C597.308 171.279 599.6 173.572 599.6 176.399V292.239H474.16V176.399Z",
    fill: "#1C7EC7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.16,
    y: 93.1992,
    width: 125.44,
    height: 117.12,
    rx: 10.24,
    fill: "#1C7EC7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.8,
    y: 150.16,
    width: 44.8,
    height: 21.12,
    rx: 5.12,
    fill: "#DAE4F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.8,
    y: 180.24,
    width: 44.8,
    height: 21.12,
    rx: 5.12,
    fill: "#DAE4F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.8,
    y: 210.32,
    width: 44.8,
    height: 21.12,
    rx: 5.12,
    fill: "#DAE4F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.8,
    y: 240.4,
    width: 44.8,
    height: 21.12,
    rx: 5.12,
    fill: "#DAE4F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.28,
    y: 150.16,
    width: 44.8,
    height: 21.12,
    rx: 5.12,
    fill: "#DAE4F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.88,
    y: 150.16,
    width: 90.88,
    height: 21.12,
    rx: 5.12,
    fill: "#F88652"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.88,
    y: 180.24,
    width: 90.88,
    height: 21.12,
    rx: 5.12,
    fill: "#F88652"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.88,
    y: 210.32,
    width: 90.88,
    height: 21.12,
    rx: 5.12,
    fill: "#F88652"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.88,
    y: 240.4,
    width: 90.88,
    height: 21.12,
    rx: 5.12,
    fill: "#F88652"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.28,
    y: 180.24,
    width: 44.8,
    height: 21.12,
    rx: 5.12,
    fill: "#DAE4F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.28,
    y: 210.32,
    width: 44.8,
    height: 21.12,
    rx: 5.12,
    fill: "#DAE4F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.28,
    y: 240.4,
    width: 44.8,
    height: 21.12,
    rx: 5.12,
    fill: "#DAE4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.521 130.96C489.521 123.891 495.251 118.16 502.321 118.16C509.39 118.16 515.121 123.891 515.121 130.96V146.32C515.121 149.148 512.828 151.44 510.001 151.44H494.641C491.813 151.44 489.521 149.148 489.521 146.32V130.96Z",
    fill: "#2C93E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.521 174.48C489.521 167.41 495.251 161.68 502.321 161.68C509.39 161.68 515.121 167.41 515.121 174.48V189.84C515.121 192.667 512.828 194.96 510.001 194.96H494.641C491.813 194.96 489.521 192.667 489.521 189.84V174.48Z",
    fill: "#2C93E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.521 217.999C489.521 210.93 495.251 205.199 502.321 205.199C509.39 205.199 515.121 210.93 515.121 217.999V233.359C515.121 236.187 512.828 238.479 510.001 238.479H494.641C491.813 238.479 489.521 236.187 489.521 233.359V217.999Z",
    fill: "#2C93E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.08 130.96C524.08 123.891 529.81 118.16 536.88 118.16C543.949 118.16 549.68 123.891 549.68 130.96V146.32C549.68 149.148 547.387 151.44 544.56 151.44H529.2C526.372 151.44 524.08 149.148 524.08 146.32V130.96Z",
    fill: "#2C93E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.08 174.48C524.08 167.41 529.81 161.68 536.88 161.68C543.949 161.68 549.68 167.41 549.68 174.48V189.84C549.68 192.667 547.387 194.96 544.56 194.96H529.2C526.372 194.96 524.08 192.667 524.08 189.84V174.48Z",
    fill: "#2C93E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.08 217.999C524.08 210.93 529.81 205.199 536.88 205.199C543.949 205.199 549.68 210.93 549.68 217.999V233.359C549.68 236.187 547.387 238.479 544.56 238.479H529.2C526.372 238.479 524.08 236.187 524.08 233.359V217.999Z",
    fill: "#2C93E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.64 130.96C558.64 123.891 564.371 118.16 571.44 118.16C578.509 118.16 584.24 123.891 584.24 130.96V146.32C584.24 149.148 581.948 151.44 579.12 151.44H563.76C560.932 151.44 558.64 149.148 558.64 146.32V130.96Z",
    fill: "#2C93E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.64 174.48C558.64 167.41 564.37 161.68 571.44 161.68C578.509 161.68 584.24 167.41 584.24 174.48V189.84C584.24 192.667 581.947 194.96 579.12 194.96H563.76C560.932 194.96 558.64 192.667 558.64 189.84V174.48Z",
    fill: "#2C93E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.64 217.999C558.64 210.93 564.371 205.199 571.44 205.199C578.509 205.199 584.24 210.93 584.24 217.999V233.359C584.24 236.187 581.948 238.479 579.12 238.479H563.76C560.932 238.479 558.64 236.187 558.64 233.359V217.999Z",
    fill: "#2C93E0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_1644",
    x: 0,
    y: 0,
    width: 784,
    height: 307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1644"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1644",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_1_1644",
    x: 0,
    y: 0,
    width: 784,
    height: 307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1644"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1644",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.958805 0 0 0 0 0.958805 0 0 0 0 0.958805 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_1644"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLanding03Large);
export default __webpack_public_path__ + "static/media/img_landing_03_large.ff7f57b2c31694c9aa50062452a36e96.svg";
export { ForwardRef as ReactComponent };